import styled from "styled-components";

export const Comment = styled.p`
  margin: 0;
  padding: 0;
  font-family: ${(props) => props.theme.fontBody};
  font-size: 20px;
`;
